import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * status／payee_id 契約為逗號多值（重複 key 回 400）；sort id 送 snake_case。
 * payee_id 只有財務管理有領款人欄才送；total_amount_min／max 為單值。
 */
function sortIdToSnake(id) {
  return String(id || '').replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

function joinCommaFilter(filters, key) {
  const value = filters[key];
  if (Array.isArray(value) && value.length > 0) {
    filters[key] = value.filter(Boolean).join(',');
  }
}

export function paymentRequestListQueryToApiParams(listQuery, { allowPayeeFilter = false } = {}) {
  const filters = { ...(listQuery?.filters || {}) };
  joinCommaFilter(filters, 'status');
  joinCommaFilter(filters, 'payeeId');
  // 個人中心不強制 payee_id；若誤帶入也剝除
  if (!allowPayeeFilter) {
    delete filters.payeeId;
  }

  const sort = (listQuery?.sort || []).map(({ id, desc }) => ({
    id: sortIdToSnake(id),
    desc: Boolean(desc),
  }));

  return listQueryToApiParams({
    ...listQuery,
    filters,
    sort,
  });
}
